import { Switch } from '@genially/design-system';

import { Label, Row } from './UserResultsToggle.styled';

interface UserResultsToggleProps {
  label: string;
  isChecked: boolean;
  onChange: () => void;
}

/**
 * The gesture that puts names in front of the room, shared by the three lists that offer
 * it. The state stays with each caller: what revealing means differs — a blurred column
 * here, a whole identity row there — and only the control itself is the same.
 */
export const UserResultsToggle = ({
  label,
  isChecked,
  onChange,
}: UserResultsToggleProps) => (
  <Row>
    <Label>{label}</Label>

    <Switch checked={isChecked} onChange={onChange} />
  </Row>
);
